import React from 'react';
import { Field, useFormState } from 'react-final-form';
import { useTranslation } from 'react-i18next';

import CommonButton, { BUTTON_STYLES } from '../../../../components/common-button/CommonButton';
import CommonTextarea from '../../../../components/common-textarea/CommonTextarea';
import WithError from '../../../../components/with-error/WithError';

import scss from './PromptModal.module.scss';

function PromptFormInner({ onCancel, AdditionalFields, handleSubmit, title, placeholder }) {
  const { t } = useTranslation('id8');

  const { submitting } = useFormState();

  return (
    <form onSubmit={handleSubmit} className={scss.wrapper}>
      <h3 className={scss.title}>{title}</h3>

      <div className={scss.fieldsBlock}>
        <Field name='description'>
          {({ meta, input }) => (
            <WithError isShowError={meta.touched && meta.error} errorText={t(meta.error)}>
              <CommonTextarea
                name={input.name}
                value={input.value}
                onChange={input.onChange}
                onFocus={input.onFocus}
                onBlur={input.onBlur}
                rows='3'
                placeholder={placeholder || t('enterYourDescription')}
                isError={meta.touched && meta.error}
                enableVoiceInput
              />
            </WithError>
          )}
        </Field>

        {AdditionalFields ? <AdditionalFields /> : null}
      </div>

      <div className={scss.actions}>
        <CommonButton
          type='button'
          onClick={onCancel}
          styleColor={BUTTON_STYLES.SECONDARY}
          maxWidth={144}
          disabled={submitting}>
          {t('cancel')}
        </CommonButton>

        <CommonButton type='submit' styleColor={BUTTON_STYLES.PRIMARY} maxWidth={144} isLoading={submitting}>
          {t('submit')}
        </CommonButton>
      </div>
    </form>
  );
}

export default PromptFormInner;
